import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { navigationLinks } from '../assets/siteData';
import brandLogo from '../assets/logo11.png';
import { Button } from './Button';

export function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="navbar-wrap">
      <div className="navbar shell glass-panel">
        <NavLink to="/" className="brand" onClick={() => setOpen(false)}>
          <img className="brand__logo" src={brandLogo} alt="VappyTech logo" />
          <span>
            <strong>VappyTech x VappyShop</strong>
            <small>INNOVATE · BUILD · ELEVATE</small>
          </span>
        </NavLink>

        <button
          className={`navbar__toggle ${open ? 'is-open' : ''}`}
          type="button"
          onClick={() => setOpen((value) => !value)}
          aria-label={open ? 'Close navigation' : 'Open navigation'}
          aria-expanded={open}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`navbar__nav ${open ? 'is-open' : ''}`}>
          {navigationLinks.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={() => setOpen(false)}
              className={({ isActive }) => `navbar__link magnetic-link ${isActive ? 'is-active' : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
          <Button to="/contact" className="navbar__cta" variant="secondary" onClick={() => setOpen(false)}>
            Hire Me
          </Button>
        </nav>
      </div>
    </header>
  );
}
